/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCustomerVaultRequest,
  ExchangePlaidTokenRequest,
  GetCustomerVaultResponse,
  RecordVaultAuthorizationRequest,
  Result,
} from '../models/index';
import {
    CreateCustomerVaultRequestFromJSON,
    CreateCustomerVaultRequestToJSON,
    ExchangePlaidTokenRequestFromJSON,
    ExchangePlaidTokenRequestToJSON,
    GetCustomerVaultResponseFromJSON,
    GetCustomerVaultResponseToJSON,
    RecordVaultAuthorizationRequestFromJSON,
    RecordVaultAuthorizationRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
} from '../models/index';

export interface ApiUsersUserIdVaultPostRequest {
    userId: number;
    createCustomerVaultRequest: CreateCustomerVaultRequest;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsAchWebPostRequest {
    userId: number;
    exchangePlaidTokenRequest: ExchangePlaidTokenRequest;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsGetRequest {
    userId: number;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsPlaidLinkTokenPostRequest {
    userId: number;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsUserVaultIdAuthorizationPostRequest {
    userId: number;
    userVaultId: number;
    recordVaultAuthorizationRequest: RecordVaultAuthorizationRequest;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsUserVaultIdDeleteRequest {
    userId: number;
    userVaultId: number;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsVaultIdDefaultPutRequest {
    userId: number;
    vaultId: number;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsVaultIdGetRequest {
    userId: number;
    vaultId: number;
    xTenantID?: number;
}

export interface ApiUsersUserIdVaultsVaultIdPutRequest {
    userId: number;
    vaultId: number;
    xTenantID?: number;
}

/**
 * 
 */
export class CustomerVaultsApi extends runtime.BaseAPI {

    /**
     * Creates a new customer vault for a given user. This requires a valid PayJunction token ID and the user must have an associated PayJunction customer ID.
     * Create new customer vault
     */
    async apiUsersUserIdVaultPostRaw(requestParameters: ApiUsersUserIdVaultPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultPost().'
            );
        }

        if (requestParameters['createCustomerVaultRequest'] == null) {
            throw new runtime.RequiredError(
                'createCustomerVaultRequest',
                'Required parameter "createCustomerVaultRequest" was null or undefined when calling apiUsersUserIdVaultPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vault`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCustomerVaultRequestToJSON(requestParameters['createCustomerVaultRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new customer vault for a given user. This requires a valid PayJunction token ID and the user must have an associated PayJunction customer ID.
     * Create new customer vault
     */
    async apiUsersUserIdVaultPost(requestParameters: ApiUsersUserIdVaultPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdVaultPostRaw(requestParameters, initOverrides);
    }

    /**
     * Exchanges Plaid\'s public token and stores a new ACH_WEB UserVault.
     * Exchange Plaid token and create ACH WEB vault
     */
    async apiUsersUserIdVaultsAchWebPostRaw(requestParameters: ApiUsersUserIdVaultsAchWebPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsAchWebPost().'
            );
        }

        if (requestParameters['exchangePlaidTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'exchangePlaidTokenRequest',
                'Required parameter "exchangePlaidTokenRequest" was null or undefined when calling apiUsersUserIdVaultsAchWebPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/ach-web`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExchangePlaidTokenRequestToJSON(requestParameters['exchangePlaidTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Exchanges Plaid\'s public token and stores a new ACH_WEB UserVault.
     * Exchange Plaid token and create ACH WEB vault
     */
    async apiUsersUserIdVaultsAchWebPost(requestParameters: ApiUsersUserIdVaultsAchWebPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiUsersUserIdVaultsAchWebPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all customer vaults for a given user.
     * Get all customer vaults for a user
     */
    async apiUsersUserIdVaultsGetRaw(requestParameters: ApiUsersUserIdVaultsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCustomerVaultResponse>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomerVaultResponseFromJSON));
    }

    /**
     * Retrieves all customer vaults for a given user.
     * Get all customer vaults for a user
     */
    async apiUsersUserIdVaultsGet(requestParameters: ApiUsersUserIdVaultsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCustomerVaultResponse>> {
        const response = await this.apiUsersUserIdVaultsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a short-lived Plaid Link token for an ACH_WEB vault.
     * Create Plaid Link token
     */
    async apiUsersUserIdVaultsPlaidLinkTokenPostRaw(requestParameters: ApiUsersUserIdVaultsPlaidLinkTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsPlaidLinkTokenPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/plaid/link-token`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Creates a short-lived Plaid Link token for an ACH_WEB vault.
     * Create Plaid Link token
     */
    async apiUsersUserIdVaultsPlaidLinkTokenPost(requestParameters: ApiUsersUserIdVaultsPlaidLinkTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiUsersUserIdVaultsPlaidLinkTokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Records the customer\'s acceptance of the ACH WEB authorization terms for a saved vault.
     * Record ACH WEB vault authorization
     */
    async apiUsersUserIdVaultsUserVaultIdAuthorizationPostRaw(requestParameters: ApiUsersUserIdVaultsUserVaultIdAuthorizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsUserVaultIdAuthorizationPost().'
            );
        }

        if (requestParameters['userVaultId'] == null) {
            throw new runtime.RequiredError(
                'userVaultId',
                'Required parameter "userVaultId" was null or undefined when calling apiUsersUserIdVaultsUserVaultIdAuthorizationPost().'
            );
        }

        if (requestParameters['recordVaultAuthorizationRequest'] == null) {
            throw new runtime.RequiredError(
                'recordVaultAuthorizationRequest',
                'Required parameter "recordVaultAuthorizationRequest" was null or undefined when calling apiUsersUserIdVaultsUserVaultIdAuthorizationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/{userVaultId}/authorization`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"userVaultId"}}`, encodeURIComponent(String(requestParameters['userVaultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordVaultAuthorizationRequestToJSON(requestParameters['recordVaultAuthorizationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Records the customer\'s acceptance of the ACH WEB authorization terms for a saved vault.
     * Record ACH WEB vault authorization
     */
    async apiUsersUserIdVaultsUserVaultIdAuthorizationPost(requestParameters: ApiUsersUserIdVaultsUserVaultIdAuthorizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdVaultsUserVaultIdAuthorizationPostRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a customer vault for a given user.
     * Delete customer vault
     */
    async apiUsersUserIdVaultsUserVaultIdDeleteRaw(requestParameters: ApiUsersUserIdVaultsUserVaultIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsUserVaultIdDelete().'
            );
        }

        if (requestParameters['userVaultId'] == null) {
            throw new runtime.RequiredError(
                'userVaultId',
                'Required parameter "userVaultId" was null or undefined when calling apiUsersUserIdVaultsUserVaultIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/{userVaultId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"userVaultId"}}`, encodeURIComponent(String(requestParameters['userVaultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a customer vault for a given user.
     * Delete customer vault
     */
    async apiUsersUserIdVaultsUserVaultIdDelete(requestParameters: ApiUsersUserIdVaultsUserVaultIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdVaultsUserVaultIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * This endpoint allows you to set a specific vault as the default vault for a user. The user will have only one default vault at a time.
     * Set Customer Vault as default
     */
    async apiUsersUserIdVaultsVaultIdDefaultPutRaw(requestParameters: ApiUsersUserIdVaultsVaultIdDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsVaultIdDefaultPut().'
            );
        }

        if (requestParameters['vaultId'] == null) {
            throw new runtime.RequiredError(
                'vaultId',
                'Required parameter "vaultId" was null or undefined when calling apiUsersUserIdVaultsVaultIdDefaultPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/{vaultId}/default`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"vaultId"}}`, encodeURIComponent(String(requestParameters['vaultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint allows you to set a specific vault as the default vault for a user. The user will have only one default vault at a time.
     * Set Customer Vault as default
     */
    async apiUsersUserIdVaultsVaultIdDefaultPut(requestParameters: ApiUsersUserIdVaultsVaultIdDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdVaultsVaultIdDefaultPutRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the details of a specific customer vault for a given user. Returns 404 if the vault is not found.
     * Get a customer vault by ID
     */
    async apiUsersUserIdVaultsVaultIdGetRaw(requestParameters: ApiUsersUserIdVaultsVaultIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerVaultResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsVaultIdGet().'
            );
        }

        if (requestParameters['vaultId'] == null) {
            throw new runtime.RequiredError(
                'vaultId',
                'Required parameter "vaultId" was null or undefined when calling apiUsersUserIdVaultsVaultIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/{vaultId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"vaultId"}}`, encodeURIComponent(String(requestParameters['vaultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerVaultResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the details of a specific customer vault for a given user. Returns 404 if the vault is not found.
     * Get a customer vault by ID
     */
    async apiUsersUserIdVaultsVaultIdGet(requestParameters: ApiUsersUserIdVaultsVaultIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerVaultResponse> {
        const response = await this.apiUsersUserIdVaultsVaultIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint allows you to update customer vault basic info such as state, city, zip and address.
     * Update Customer Vault
     */
    async apiUsersUserIdVaultsVaultIdPutRaw(requestParameters: ApiUsersUserIdVaultsVaultIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdVaultsVaultIdPut().'
            );
        }

        if (requestParameters['vaultId'] == null) {
            throw new runtime.RequiredError(
                'vaultId',
                'Required parameter "vaultId" was null or undefined when calling apiUsersUserIdVaultsVaultIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{userId}/vaults/{vaultId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"vaultId"}}`, encodeURIComponent(String(requestParameters['vaultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint allows you to update customer vault basic info such as state, city, zip and address.
     * Update Customer Vault
     */
    async apiUsersUserIdVaultsVaultIdPut(requestParameters: ApiUsersUserIdVaultsVaultIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdVaultsVaultIdPutRaw(requestParameters, initOverrides);
    }

}
